import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const seatsApi = createApi({
  reducerPath: "seatsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Seats"],
  endpoints: (builder) => ({
    getSeats: builder.query({
      query: () => "/seats",
      transformResponse: (response) => response.data || { seats: [], used: 0, max: 3, remaining: 3 },
      providesTags: ["Seats"],
    }),
    inviteSeat: builder.mutation({
      query: (data) => ({
        url: "/seats/invite",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Seats"],
    }),
    updateSeatPermissions: builder.mutation({
      query: ({ seatId, ...data }) => ({
        url: `/seats/${seatId}/permissions`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Seats"],
    }),
    resetSeatPassword: builder.mutation({
      query: (seatId) => ({
        url: `/seats/${seatId}/reset-password`,
        method: "PUT",
      }),
      invalidatesTags: ["Seats"],
    }),
    revokeSeat: builder.mutation({
      query: (seatId) => ({
        url: `/seats/${seatId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Seats"],
    }),
    getLeadRouting: builder.query({
      query: () => "/seats/lead-routing",
      transformResponse: (response) => response.data || { routing: { enabled: false, method: "round_robin" }, members: [] },
      providesTags: ["LeadRouting"],
    }),
    updateLeadRouting: builder.mutation({
      query: (data) => ({
        url: "/seats/lead-routing",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["LeadRouting"],
    }),
  }),
});

export const {
  useGetSeatsQuery,
  useInviteSeatMutation,
  useUpdateSeatPermissionsMutation,
  useResetSeatPasswordMutation,
  useRevokeSeatMutation,
  useGetLeadRoutingQuery,
  useUpdateLeadRoutingMutation,
} = seatsApi;
